import React, { useState } from 'react';
import { Container, Paper, TextField, Button, Typography, Box, Alert, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) { setError('Email is required'); return; }
    setError(''); setSubmitting(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      // Don't leak whether the email exists — show generic success
      setSent(true);
    } finally { setSubmitting(false); }
  };

  if (sent) {
    return (
      <Container maxWidth="sm" sx={{ mt: 8 }}>
        <Paper sx={{ p: 5, borderRadius: 3, textAlign: 'center' }}>
          <Typography variant="h3" sx={{ fontWeight: 800, color: '#1a237e', mb: 1 }}>Yaplar</Typography>
          <Box sx={{ fontSize: 64, my: 2 }}>📧</Box>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Check your email</Typography>
          <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
            If an account exists for <strong>{email}</strong>, we've sent you a link to reset your password. The link expires in 15 minutes.
          </Typography>
          <Button variant="contained" component={Link} to="/login" sx={{ bgcolor: '#1a237e', borderRadius: 2, px: 4 }}>
            Back to sign in
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper sx={{ p: 5, borderRadius: 3 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography variant="h3" sx={{ fontWeight: 800, color: '#1a237e', mb: 0.5 }}>Yaplar</Typography>
          <Typography variant="body2" sx={{ color: '#666' }}>Reset your password</Typography>
        </Box>
        <Typography variant="body2" sx={{ color: '#666', mb: 3 }}>
          Enter the email associated with your account. We'll send you a link to reset your password.
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={submit}>
          <TextField label="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} fullWidth required size="small" sx={{ mb: 3 }} autoFocus />
          <Button type="submit" variant="contained" fullWidth size="large" disabled={submitting}
            sx={{ bgcolor: '#1a237e', borderRadius: 2, py: 1.5, mb: 2, fontWeight: 700, '&:hover': { bgcolor: '#283593' } }}>
            {submitting ? 'Sending…' : 'Send reset link'}
          </Button>
          <Typography variant="body2" sx={{ textAlign: 'center', color: '#666' }}>
            Remembered? <MuiLink component={Link} to="/login" sx={{ color: '#1a237e', fontWeight: 600 }}>Sign in</MuiLink>
          </Typography>
        </form>
      </Paper>
    </Container>
  );
}
